import { render, staticRenderFns } from "./DetailStudy.vue?vue&type=template&id=8912679c&scoped=true&"
import script from "./DetailStudy.vue?vue&type=script&lang=js&"
export * from "./DetailStudy.vue?vue&type=script&lang=js&"
import style0 from "./DetailStudy.vue?vue&type=style&index=0&id=8912679c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8912679c",
  null
  
)

export default component.exports